import React from 'react'
import Box from '@mui/material/Box';
import GridStructure from './GridStructure';
import { dlVerificationDataList } from '../../constants/externalInformationData';

function DLVerification({ content }) {
    return (
        (content && Object?.keys(content)?.length)
            ?
            <Box>
                <GridStructure
                    gridDataList={dlVerificationDataList}
                    content={{
                        ...content?.detailsOfDrivingLicence,
                        message: content?.is_dl_verified ? "Driving license verification process completed successfully with positive result." : ""
                    }}
                    tab={"dlVerification"}
                />
            </Box>
            :
            <div
                style={{
                    margin: "20px 7px",
                    display: "flex",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "grey",
                }}
            >
                <h3>No data</h3>
            </div>
    )
}

export default DLVerification